import { Typography } from "@/frontend/shared/ui/Typography";
import styles from "./ProductsSection.module.scss";
import { NormalButton } from "@/frontend/shared/ui/Button";
import { useState } from "react";
import { UploadLogo } from "@/frontend/shared/ui/UploadLogo/UploadLogo";
import { Input } from "@/frontend/shared/ui/Input";
import { Textarea } from "@/frontend/shared/ui/Textarea/Textarea";
import { Tag } from "@/frontend/shared/ui/Tag";
import {
  EditIcon,
  G2CrowdIcon,
  ProductHuntIcon,
  TrashIcon,
  TrustPilotIcon,
  UserIcon
} from "@/frontend/shared/assets/icons";

export function ProductsSection() {
  const [isProductContainerShown, setIsProductContainerShown] = useState(false);
  const [formData, setFormData] = useState({
    image: "",
    name: "",
    videoUrl: "",
    productUrl: "",
    description: "",
    tag: "",
    tags: ["tag1", "tag2"],
    productHunt: "",
    g2crows: "",
    trustPilot: "",
    isEdited: false
  });

  const [cards, setCards] = useState([
    {
      image: "",
      name: "ChatGPT",
      videoUrl: "http://test.com",
      productUrl: "www.test.com",
      description:
        "ChatGPT is a natural language processing chatbot driven by generative AI that allows you to have human-like conversations to complete various tasks.",
      tags: ["tag1", "tag2"],
      productHunt: "1231",
      g2crows: "1231",
      trustPilot: "123"
    }
  ]);

  const [errorMessages, setErrorMessages] = useState({
    nameError: ""
  });

  function handleAddProduct() {
    if (!formData.name.trim()) {
      setErrorMessages((prev) => ({ ...prev, nameError: "Name is required." }));
    } else {
      setCards([...cards, { ...formData }]);
      setFormData({
        image: "",
        name: "",
        videoUrl: "",
        productUrl: "",
        description: "",
        tag: "",
        tags: [],
        productHunt: "",
        g2crows: "",
        trustPilot: "",
        isEdited: false
      });
      setIsProductContainerShown(false);
    }
  }

  function handleEditInit(index: number) {
    const product = cards[index];
    setFormData({
      ...product,
      tag: "",
      isEdited: true
    });
    setErrorMessages((prev) => ({ ...prev, nameError: "" }));
    setIsProductContainerShown(true);
  }

  function handleEditProduct() {
    setCards((prev) => {
      return prev.map((card) => {
        if (card.name === formData.name) {
          return { ...formData };
        }
        return card;
      });
    });
    setIsProductContainerShown(true);
  }

  function handleDeleteProduct(index: number) {
    setCards(cards.filter((_, i) => i !== index));
  }

  const content = isProductContainerShown && (
    <div className={styles.contentContainer}>
      <UploadLogo
        image={formData.image}
        onRemove={() => setFormData((prev) => ({ ...prev, image: "" }))}
        onUpload={(e) => setFormData((prev) => ({ ...prev, image: e }))}
        text="Upload Image"
      />
      <div>
        <Typography className={styles.subTitleText}>Name*</Typography>
        <Input
          value={formData.name}
          onChange={(e) => setFormData((prev) => ({ ...prev, name: e.target.value }))}
          placeholder="Product name"
          error={errorMessages.nameError}
        />
      </div>
      <div>
        <Typography className={styles.subTitleText}>Video URL</Typography>
        <Input
          value={formData.videoUrl}
          onChange={(e) => setFormData((prev) => ({ ...prev, videoUrl: e.target.value }))}
          placeholder="Video URL"
        />
      </div>
      <div>
        <Typography className={styles.subTitleText}>Product URL</Typography>
        <Input
          value={formData.productUrl}
          onChange={(e) => setFormData((prev) => ({ ...prev, productUrl: e.target.value }))}
          placeholder="Product URL"
        />
      </div>
      <div>
        <Typography className={styles.subTitleText}>Description</Typography>
        <Textarea
          value={formData.description}
          onChange={(e) => setFormData((prev) => ({ ...prev, description: e.target.value }))}
          placeholder="Product description"
        />
      </div>
      <div>
        <Typography className={styles.subTitleText}>Tags</Typography>
        <Input
          value={formData.tag}
          onChange={(e) => setFormData((prev) => ({ ...prev, tag: e.target.value }))}
          placeholder="ie. Public, Computer Vision,  IOT, "
        />
      </div>
      <div>
        <Typography className={styles.subTitleText}>Social media</Typography>
        <div className={styles.socialMediaInputs}>
          <Input
            value={formData.productHunt}
            onChange={(e) => setFormData((prev) => ({ ...prev, productHunt: e.target.value }))}
            placeholder="Product Hunt"
          />
          <Input
            value={formData.g2crows}
            onChange={(e) => setFormData((prev) => ({ ...prev, g2crows: e.target.value }))}
            placeholder="G2Crowd"
          />
          <Input
            value={formData.trustPilot}
            onChange={(e) => setFormData((prev) => ({ ...prev, trustPilot: e.target.value }))}
            placeholder="TrustPilot"
          />
        </div>
      </div>
      <div className={styles.bottomButtonContainer}>
        <NormalButton size="medium" onClick={handleAddProduct}>
          Add Product
        </NormalButton>
        <NormalButton
          size="medium"
          variant="tertiary"
          color="greyscale600"
          onClick={() => setIsProductContainerShown(false)}
        >
          Cancel
        </NormalButton>
      </div>
    </div>
  );

  return (
    <div className={styles.container}>
      <Typography variant="heading-6" color="greyscale900">
        Products
      </Typography>
      <div className={styles.emptyContentContainer}>
        <Typography color="greyscale700" variant="label-4">
          List of products
        </Typography>
        <div className={styles.cardsContainer}>
          {cards.map((item, index) => {
            return (
              <div className={styles.cardContainer}>
                {item.image ? (
                  <img src={item.image} alt="image" className={styles.image} />
                ) : (
                  <div className={styles.placeholderIconContainer}>
                    <UserIcon />
                  </div>
                )}
                <div className={styles.cardContentContainer}>
                  <div className={styles.headerContainer}>
                    <div className={styles.companyNameContainer}>
                      <Typography variant="heading-7" color="greyscale900">
                        {item.name}
                      </Typography>
                      <div className={styles.leftsideIconsContainer}>
                        {item.productHunt && <ProductHuntIcon />}
                        {item.g2crows && <G2CrowdIcon />}
                        {item.trustPilot && <TrustPilotIcon />}
                      </div>
                    </div>
                    <div className={styles.actionIconsContainer}>
                      <EditIcon onClick={() => handleEditInit(index)} />
                      <TrashIcon onClick={() => handleDeleteProduct(index)} />
                    </div>
                  </div>
                  <Typography variant="body-2" color="greyscale700">
                    {item.productUrl}
                  </Typography>
                  <div className={styles.tagsContainer}>
                    {item.tags &&
                      item.tags.map((tag) => {
                        return <Tag size="small">{tag}</Tag>;
                      })}
                  </div>
                  <Typography variant="body-2" color="greyscale700" className={styles.cardDescription}>
                    {item.description}
                  </Typography>
                </div>
              </div>
            );
          })}
        </div>
        {content}
        <NormalButton
          variant="secondary"
          color="greyscale800"
          size="medium"
          onClick={() => setIsProductContainerShown(true)}
          className={styles.addProductBtn}
        >
          Add Product
        </NormalButton>
      </div>
      <div className={styles.bottomButtonsContainer}>
        <NormalButton size="large">Proceed</NormalButton>
        <NormalButton size="large" variant="secondary" color="greyscale800">
          Step back
        </NormalButton>
      </div>
    </div>
  );
}
